import React from 'react';
import { FaExchangeAlt } from 'react-icons/fa';
import RemoveIcon from '../icons/remove.svg';
import AddIcon from '../icons/add.svg';

const WaterMeterIcon = ({ type }) => {
  if (type === 'remove') {
    return <img src={RemoveIcon} alt="Remove Water Meter" />;
  } else if (type === 'add') {
    return <img src={AddIcon} alt="Add Water Meter" />;
  } else if (type === 'replace') {
    return <FaExchangeAlt alt="Replace Water Meter" />;
  }
  return null;
};

export default WaterMeterIcon;